import { __makeTemplateObject } from "tslib";
import { css, keyframes } from 'styled-components';
import { rgba } from 'polished';
import { createComponent } from '../utils';
var spin = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from { transform: rotate(0deg); }\n  from { transform: rotate(360deg); }\n"], ["\n  from { transform: rotate(0deg); }\n  from { transform: rotate(360deg); }\n"])));
var Spinner = createComponent({
    name: 'Spinner',
    style: function (_a) {
        var _b = _a.size, size = _b === void 0 ? 15 : _b;
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: ", "px;\n    width: ", "px;\n    border: ", "px solid ", ";\n    border-right-color: ", ";\n    border-radius: 50%;\n    animation: ", " 1.1s infinite linear;\n  "], ["\n    height: ", "px;\n    width: ", "px;\n    border: ", "px solid ", ";\n    border-right-color: ", ";\n    border-radius: 50%;\n    animation: ", " 1.1s infinite linear;\n  "])), size, size, size / 10, function (p) { return rgba(p.theme.colors.primary, 0.3); }, function (p) { return p.theme.colors.primary; }, spin);
    },
});
export default Spinner;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Spinner.js.map